import { Label, Input } from "@tellescope/design-system";
import { cn } from "@tellescope/utils";
import { useTranslation } from "react-i18next";
import { TellescopeFormFieldBaseProps } from "../types";
import { FieldDescription } from "../FieldDescription";

export interface EmailFieldProps extends TellescopeFormFieldBaseProps<"email"> {}

export const EmailField = ({
  title,
  description,
  htmlDescription,
  placeholder,
  value,
  onChange,
  className,
  error,
  onBlur,
  touched,
  disabled,
  required,
  autoFocus,
}: EmailFieldProps) => {
  const { t } = useTranslation("forms");
  const showError = !!(error && touched);
  const resolvedPlaceholder = placeholder ?? t("Enter email...");

  return (
    <div className="space-y-1">
      <Label required={required}>{title || resolvedPlaceholder}</Label>
      <FieldDescription description={description} htmlDescription={htmlDescription} />
      <Input
        type="email"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={resolvedPlaceholder}
        className={cn(className, showError && "border-destructive")}
        aria-invalid={showError}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
